




















import { Component, Vue } from "@/shared/vuepack";
import {
  FetchState,
  UserPermission
} from "@/shared/types";
import * as RouteNames from "@/admin/route-names";
import { useAdvisorStore } from "@/admin/store/advisor";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
  }
})
export default class ActionList extends Vue {

  advisorStore = useAdvisorStore();
  rolePermissionStore = useRolePermissionsStore();
  featureFlagStore = useFeatureFlagStore();

  pageNumber = 1;
  showFields = [
    {
      key: "name",
      label: "Name"
    },
    {
      key: "delayType",
      label: "Delay Type"
    },
    {
      key: "delayValue",
      label: "Delay Value"
    },
    {
      key: "deliveryChannel",
      label: "Channel"
    },
    {
      key: "deliveryPage",
      label: "Page"
    },
    "actions"
  ];

  get allActions () {
    if (this.advisorStore.forceRefresh) {
      this.advisorStore.loadAllActions();
    }

    return this.advisorStore.actions;
  }

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
      ? this.rolePermissionStore.userHasAdminPermission(UserPermission.AdminPortalAdvisorEdit)
      : true;
  }

  mounted () {
    if (this.advisorStore.actionFetchAllState === FetchState.Uninitialized) {
      this.advisorStore.loadAllActions();
    }
  }

  formatLink (id: number) {
    return { name: RouteNames.AdvisorAction, params: { actionId: id.toString() } };
  }

  get isLoading (): boolean {
    return this.advisorStore.actionFetchAllState === FetchState.Loading;
  }
}
